import * as actionTypes from '../Actions/ActionTypes'

/* Persisted (redux-persist, see Stores/index.js): the anonymous profile's
   token must survive reloads, or the user's topics are lost. */
const initialState = {
  token: null,
  items: [], // the user's topics, as GET /api/me/topics returns them
}

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_MY_TOPICS_TOKEN:
      return { ...state, token: action.payload.token }
    case actionTypes.SET_MY_TOPICS:
      return { ...state, items: action.payload.items }
    default:
      return state
  }
}
